
import { defineComponent, reactive, onMounted, ref, watch, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from 'vue-i18n';

import { ethitransService } from "@/services/EthitransService";
import ErrorList from "@/components/commonDesign/ErrorList.vue";

import ToDoDetailsAttachment from "@/components/todo/ToDoDetailsAttachment.vue";
import HistoryTimeLine from "@/components/projectDetail/HistoryTimeLine.vue";

import { validationService } from "@/common/ValidationService";
import { common } from "@/common/services/Common";
import { config } from "@/Config";
import EmptyData from "../commonDesign/EmptyData.vue";
import SignaturePadModal from "@/components/modal/SignaturePadModal.vue";
import SignatureUploadModal from "@/components/modal/SignatureUploadModal.vue";
import SuccessfulModalCustom from "@/components/modal/SuccessfulModalCustom.vue";
export default defineComponent({
  name: "ProjectAcknowledgement",
  components: {
    ToDoDetailsAttachment,
    HistoryTimeLine,
    // TemplateCard,
    // HistoryCard,
    // EmptyData,
    ErrorList,
    SignaturePadModal,
    SignatureUploadModal,
    SuccessfulModalCustom,
  },
  setup() {
    const canvas = ref();
    let signaturePad: any;
    const router = useRouter();
    const route = useRouter();
    const {
      params: { invitationId },
    } = useRoute();
    const { t } = useI18n();
    const routerQuery = useRoute();
    const signatureInput = ref<HTMLInputElement | null>(null);
    // console.log("CHECK ID, >>", projectId);
    const state = reactive({
      canvas: {} as any,
      data: {
        showSuccesCustomModal: false,
        successFulMessage: "",
        haveProfileSign: false,
        useProfileSign: false,
        showSignaturePad: false,
        showSignatureUpload: false,
        uploadSignatureFile: "" as any,
        projectTimeline: {} as any,
        signatureLink: "" as any,
        contract: '' as any,
        leagelDocuments: '' as any,
        cropImage: "",
        imageBaseUrl: "",
        timeCount: 130,
        cropSignature: "" as any,
        newUploadImge: "" as any,
        uploadImageData: {} as any,
        sendPhases: [] as any,
        slectedPhases: [] as any,
        projectId: "" as any,
        acknowledgementDetails: {
          description: '',
          attachments: [],
          payerRequest: {} as any,
          payers: [],
          project: {},
          "smart_contract":{
            status:null
          }
        },
        channelIndex: 0,
        inviteAsGuest: false,
        signatureFileName: "" as any,
        uploadSignature: "" as any,
      },
      ui: {
        modal: {
          showProjectAcknowledgementModal: false,
        },
        isLoading: {
          projectAcknowledgementDetails: false,
        },
        isPostLoading: {
          redirectToChat: false,
          acknowledgeProject: false,
          declineProject: false,
          phaseAcknowledgementDetails: false,
          checkSignature: false,
        },
        errors: {
          errorList: {
            phaseAcknowledgementDetails: [] as any,
            projectAcknowledgementDetails: [] as any,
          },
          hasError: false,
        },
      },
    });
    state.ui.errors.errorList
    function redirectToDoc() {
      window.open(state.data.acknowledgementDetails.payerRequest.edoc_id, "_blank");
    }
    function redirectBack() {
      // admin-invitation
      router.push({
        name: 'admin-invitation',
      });

    }
    function redirectToChat() {
      state.ui.errors.errorList.projectAcknowledgementDetails = [];
      state.ui.errors.hasError = false;
      if (state.ui.isPostLoading.redirectToChat) return false;
      state.ui.isPostLoading.redirectToChat = true;
      ethitransService
        .payerDiscussionChannel(invitationId.toString())
        .then((res: any) => {
          router.push({
            name: 'admin-channel',
            params: { channelId: res.data.data.channel.uuid.toString() },
          });
          console.log("Acknowledge Project Response:>>> ", res.data.data.channel);
        })
        .catch((error: any) => {
          common
            .sdCatchErr(
              error,
              state.ui.errors.errorList.projectAcknowledgementDetails
            )
            .then((res: any) => {
              state.ui.errors.hasError = true;
              for (const [key, value] of Object.entries(res)) {
                if (Array.isArray(value)) {
                  state.ui.errors.errorList.projectAcknowledgementDetails.push(
                    value[0]
                  );
                }
              }
            });
        })
        .finally(() => {
          state.ui.isPostLoading.redirectToChat = false;
        });
    }
    function closeSuccessCustomModal() {
      state.data.showSuccesCustomModal = !state.data.showSuccesCustomModal;
      $("#SuccessfulModalCustom").modal("hide");
      redirectBack();
    }
    // function redirectToSmartContractList() {
    //   closeSuccessCustomModal();
    //   route.push({
    //     name: "smart-contract-list",
    //     params: { projectId: state.data.projectId },
    //     query: { tab: "smartContract" }
    //   });
    // }
    //  use for new workflow-design
    function redirectToSmartContractList() {
      closeSuccessCustomModal();
      route.push({
        name: "admin-project-details",
        params: { projectId: state.data.projectId },
        query: { tab: "smartContract" }
      });
    }

    function redirectToDashboard() {
      closeSuccessCustomModal();
      router.push({
        name: "admin-dashboard",
      });
    }
    function validateForm() {
      if (!state.data.uploadSignature && !state.data.signatureLink) {
        state.ui.errors.errorList.phaseAcknowledgementDetails.push(t('use_upload_draw_your_valid_signature'));
        state.ui.isPostLoading.checkSignature = true;
      }
      if (!state.data.slectedPhases.length && state.data.slectedPhases.length == 0) {
        state.ui.errors.errorList.projectAcknowledgementDetails.push(t('phase_required'));
      }

      if (!state.ui.errors.errorList.phaseAcknowledgementDetails && !state.ui.errors.errorList.phaseAcknowledgementDetails.length) {
        state.ui.errors.hasError = false;
      } else if (state.ui.errors.errorList.phaseAcknowledgementDetails.length != 0) {
        state.ui.errors.hasError = true;
      }
    }

    function acceptEstimation() {
      state.data.slectedPhases = [];
      state.ui.errors.errorList.phaseAcknowledgementDetails = [];
      state.ui.errors.hasError = false;
      state.data.sendPhases.forEach((phase: any) => {
        if (phase.isChecked) {
          state.data.slectedPhases.push(phase.id);
        }
      })
      validateForm();
      if (state.ui.isPostLoading.acknowledgeProject || state.ui.errors.errorList.phaseAcknowledgementDetails.length != 0 || state.ui.errors.hasError) return false;
      state.ui.isPostLoading.acknowledgeProject = true;
      const payLoad = {
        id: invitationId.toString(),
        signature: state.data.uploadSignature,
        // eslint-disable-next-line @typescript-eslint/camelcase
        signature_link: state.data.signatureLink,
        phases: state.data.slectedPhases,
      };
      state.ui.isPostLoading.acknowledgeProject = true;
      ethitransService
        .acceptEstimation(payLoad)
        .then((res: any) => {
          state.data.successFulMessage = t('smart_contract_accepted');
          state.data.showSuccesCustomModal = !state.data.showSuccesCustomModal;
          state.data.acknowledgementDetails.payerRequest.status = 2;
        })
        .catch((error: any) => {
          common
            .sdCatchErr(
              error,
              state.ui.errors.errorList.projectAcknowledgementDetails
            )
            .then((res: any) => {
              state.ui.errors.hasError = true;
              for (const [key, value] of Object.entries(res)) {
                if (Array.isArray(value)) {
                  state.ui.errors.errorList.projectAcknowledgementDetails.push(
                    value[0]
                  );
                }
              }
            });
        })
        .finally(() => {
          state.ui.isPostLoading.acknowledgeProject = false;
          state.data.uploadSignature = '';
          state.data.slectedPhases = [];
          // router.push({ name: "admin-invitation", });
        });
      // alert("Acknowledge Project");
    }
    function closeAcknowledgementInvitationModal() {
      $("#deleteAcknowledgementInvitationModal").modal("hide");
      router.push({ name: "admin-invitation", });
    }
    function declineProject() {
      state.data.slectedPhases = [];
      state.ui.errors.errorList.projectAcknowledgementDetails = [];
      state.ui.errors.hasError = false;
      if (state.ui.isPostLoading.declineProject) return false;
      if (!state.data.acknowledgementDetails.description) return false;
      state.data.sendPhases.forEach((phase: any) => {
        if (phase.isChecked) {
          state.data.slectedPhases.push(phase.id);
        }
      })
      const payLoad = {
        id: invitationId.toString(),
        description: state.data.acknowledgementDetails.description,
        phases: state.data.slectedPhases,
      };
      state.ui.isPostLoading.declineProject = true;
      ethitransService
        .declineProjectApprovalInvitation(payLoad)
        .then((res: any) => {
          // console.log("Decline Project Response:>>> ", res.data.data);
          // res.data.data.payerRequest.localStartedDate = common.localDateAndTime(
          //   res.data.data.payerRequest.start_date
          // );
          // res.data.data.payerRequest.localEndDate = common.localDateAndTime(
          //   res.data.data.payerRequest.end_date
          // );
          // res.data.data.attachments.forEach((attachment: any) => {
          //   // attachment.file_size
          //   attachment.convertedFileSize = common.formatBytes(
          //     parseInt(attachment.file_size)
          //   );
          // });
          // // res.data.data.payerRequest.status = 3;
          // state.data.acknowledgementDetails = res.data.data;
          // state.data.acknowledgementDetails.payerRequest.status = 3;
          state.data.acknowledgementDetails.payerRequest.status = 2;
          closeAcknowledgementInvitationModal();
        })
        .catch((error: any) => {
          common
            .sdCatchErr(
              error,
              state.ui.errors.errorList.projectAcknowledgementDetails
            )
            .then((res: any) => {
              state.ui.errors.hasError = true;
              for (const [key, value] of Object.entries(res)) {
                if (Array.isArray(value)) {
                  state.ui.errors.errorList.projectAcknowledgementDetails.push(
                    value[0]
                  );
                }
              }
            });
        })
        .finally(() => {
          state.ui.isPostLoading.declineProject = false;
        });
    }

    function showDeclineModal() {
      state.data.acknowledgementDetails.description = '';
      $("#deleteAcknowledgementInvitationModal").modal("show");
    }
    function projectAcknowledgementDetails(id: any) {
      const invitationId: any = id;
      state.ui.errors.errorList.projectAcknowledgementDetails = [];
      state.ui.errors.hasError = false;
      if (state.ui.isLoading.projectAcknowledgementDetails) return false;
      state.ui.isLoading.projectAcknowledgementDetails = true;
      ethitransService
        .projectAcknowledgementRequestDetail(invitationId.toString())
        .then((res: any) => {
          console.log('The response is>>>>', res.data.data)
          state.data.contract = res.data.data.smart_contract.acknowledgement;
          state.data.projectId = res.data.data.smart_contract.project_id;
          // eslint-disable-next-line @typescript-eslint/camelcase
          state.data.leagelDocuments = res.data.data.smart_contract.legal_statement;
          res.data.data.payerRequest.localStartedDate = common.localDateOnly(
            res.data.data.payerRequest.start_date
          );
          res.data.data.payerRequest.localEndDate = common.localDateOnly(
            res.data.data.payerRequest.end_date
          );
          if (res.data.data.payerRequest.history && res.data.data.payerRequest.history.length) {
            res.data.data.payerRequest.history.forEach((history: any) => {
              if (history.changes && history.changes.length) {
                history.changes.forEach((change: any) => {
                  if (change.old_documents && change.old_documents.length) {
                    change.old_documents.forEach((oldDoc: any) => {
                      oldDoc.activeLink = config.liveImageBaseUrl + oldDoc.file_link;

                    })
                  }
                  if (change.new_documents && change.new_documents.length) {
                    change.new_documents.forEach((newDoc: any) => {
                      newDoc.activeLink = config.liveImageBaseUrl + newDoc.file_link;

                    })
                  }
                })
              }
            });
          }
          if (res.data.data.attachments && res.data.data.attachments.length) {

            res.data.data.attachments.forEach((attachment: any) => {
              attachment.activeLink = config.liveImageBaseUrl + attachment.file_link;
              attachment.convertedFileSize = common.formatBytes(
                parseInt(attachment.file_size)
              );
            });

          }
          res.data.data.phases.forEach((phase: any) => {
            phase.isChecked = true;
            phase.startDate = common.localDateOnly(phase.start_date);
            phase.budget = common.usdPriceFormate(phase.budget);
            phase.endDate = common.localDateOnly(phase.end_date);
            phase.child_phases.forEach((child: any) => {
              child.budget = common.usdPriceFormate(child.budget);
              child.isChecked = true;
              child.startDate = child.start_date ? common.localDateOnly(child.start_date) : '-';
              child.endDate = child.end_date ? common.localDateOnly(child.end_date) : '-';
            });
          });

          state.data.sendPhases = res.data.data.phases;

          state.data.projectTimeline = res.data.data.smart_contract.project_date;
          console.log('The Send Phase data is>>', state.data.sendPhases);
          res.data.data.payerRequest.budget = common.formatCurrency(res.data.data.payerRequest.budget);
          /* eslint-disable @typescript-eslint/camelcase */
          res.data.data.payerRequest.created_at = common.localDateOnly(res.data.data.payerRequest.created_at);
          res.data.data.approved_signers.forEach((sign: any) => {
            sign.date = common.localDateOnly(sign.signature_date);
          })
          state.data.acknowledgementDetails = res.data.data;
        })
        .catch((error: any) => {
          common
            .sdCatchErr(
              error,
              state.ui.errors.errorList.projectAcknowledgementDetails
            )
            .then((res: any) => {
              state.ui.errors.hasError = true;
              for (const [key, value] of Object.entries(res)) {
                if (Array.isArray(value)) {
                  state.ui.errors.errorList.projectAcknowledgementDetails.push(
                    value[0]
                  );
                }
              }
            });
        })
        .finally(() => {
          state.ui.isLoading.projectAcknowledgementDetails = false;
        });
    }


    function showUploadImageModel() {
      $("#updateUpload").modal("show");
    }


    function hideShowUploadImageModel() {
      $("#profileUpdate").val('');
      $("#updateUpload").modal("hide");
    }

    function readSignature(file: any) {
      const data = {} as any;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
        const extensionLower = extension.toLowerCase();
        data.base64 = e.target.result;
        data.duplicateFile = false; // data.fileName = file.name;
        data.fileName = file.name.replaceAll(`.${extension}`, "");
        data.extension = extensionLower;
        data.isuploded = false;
        data.tag = [] as any;
        data.size = common.formatBytes(parseInt(file.size));
        // state.data.uploadImageData = data;
        state.data.newUploadImge = data.base64;
        state.data.cropImage = data.base64;
        state.data.signatureFileName = data.fileName;
      };
      reader.readAsDataURL(file);
    }

    function onDocumentChange(event: any) {
      const files = event.target.files || event.dataTransfer.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        // console.log("FILE CHECK >>>", file);
        // if(file.type)
        const extension = file.name.substring(file.name.lastIndexOf(".") + 1);
        const extensionLower = extension.toLowerCase();
        readSignature(file);
        $("#updateUpload").modal("show");
      }
    }

    function saveSignature() {
      hideShowUploadImageModel();
    }

    function clearSignature() {
      state.data.cropSignature = "";
      signaturePad.clear();
    }




    function slectedPhases(phase: any) {
      state.data.sendPhases[phase].isChecked = !state.data.sendPhases[phase].isChecked
    }

    watch(
      () => routerQuery.params.invitationId,
      (newvalue, oldvalue) => {
        ``
        // console.log("Hello", newvalue);
        if (newvalue) {
          projectAcknowledgementDetails(newvalue);
        }
        //  scrollAtButton();
      }
    );
    function handleImageInNewTab(url: any) {
      window.open(config.liveImageBaseUrl + url, '_blank');
    }

    function showSignaturePad() {
      state.data.showSignaturePad = !state.data.showSignaturePad;
    }

    function hideSignaturePad() {
      state.data.showSignaturePad = !state.data.showSignaturePad;
      $("#signaturePadModal").modal("hide");
    }

    // function hideSignatureUpload() {
    //   state.data.showSignatureUpload = false;
    //   $("#signatureUploadModal").modal("hide");
    // }
    function hideSignatureUpload() {
            state.data.showSignatureUpload = false;
            if (signatureInput.value) {
                signatureInput.value.value = '';
            }
        }
    function uploadSignature(data: any) {
      state.data.signatureLink = "";
      state.data.cropSignature = data;
      state.data.uploadSignature = data;
      state.data.useProfileSign = false;
    }

    // function uploadSignatureFile(event: any) {
    //   state.data.showSignatureUpload = true;
    //   state.data.useProfileSign = false;
    //   state.data.uploadSignatureFile = event.target.files || event.dataTransfer.files;
    // }
    function uploadSignatureFile(event: any) {
      const files = event.target.files || event.dataTransfer.files;
      if (files && files.length > 0) {
        state.data.uploadSignatureFile = files;
        state.data.showSignatureUpload = true;
        nextTick(() => {
          if (signatureInput.value) {
            signatureInput.value.value = '';
          }
        });
      }
    }

    function userSignature(from: any) {
      ethitransService
        .userSignature()
        .then((res: any) => {

          if (from == 'onMount' && res.data.data.signature) {
            state.data.haveProfileSign = true;
          }
          if (from == 'use' && res.data.data.signature) {
            state.data.useProfileSign = true;
            state.data.uploadSignature = "";
            state.data.cropSignature = res.data.data.signature;
            state.data.signatureLink = res.data.data.signature;
          }
        })
        .catch((error: any) => {
          //   common
        })
    }
    function calculateTaskDays(timeline: any) {
      console.log('The timeline is>>> ', timeline);

      if (!timeline || timeline.type == null || (timeline.type !== 4 && timeline.value == null)) {
        return '0 days';
      }

      let days = 0;
      let isTBD = false;

      const type = String(timeline.type);
      const value = Number(timeline.value);

      switch (type) {
        case '1': // days
          days = value;
          break;
        case '2': // weeks
          days = value * 7;
          break;
        case '3': // months
          days = value * 30;
          break;
        case '4': // TBD
          isTBD = true;
          break;
      }

      // Only subtract weekends if checkbox is selected
      if (timeline.excludeWeekends === 1 && days > 0) {
        const fullWeeks = Math.floor(days / 7);
        const excludedWeekends = fullWeeks * 2;
        console.log('Excluding weekends:', excludedWeekends, 'from', days);
        days -= excludedWeekends;
        console.log('Days after excluding weekends:', days);
      }

      const result = (days === 0 && isTBD) ? 'TBD' : isTBD ? `${days} + TBD days` : `${days} days`;
      console.log('Final result:', result);
      return result;
    }

    function getPhaseTotalDays(phase: any) {
      let totalDays = 0;
      let hasTBD = false;
      const tasks = phase.child_phases || phase.groupTasks || [];
      tasks.forEach((task: any) => {
        const timeline = task.time_line;

        // if (!timeline || timeline.value == null || timeline.type == null) return;

        let days = 0;

        switch (timeline.type.toString()) {
          case '1': // Days
            days = Number(timeline.value);
            break;
          case '2': // Weeks
            days = Number(timeline.value) * 7;
            break;
          case '3': // Months
            days = Number(timeline.value) * 30;
            break;
          case '4': // TBD
            hasTBD = true;
            break;
          default:
            break;
        }

        if (timeline.excludeWeekends === 1 && days > 0) {
          const fullWeeks = Math.floor(days / 7);
          const excludedWeekends = fullWeeks * 2;
          days -= excludedWeekends;
        }

        totalDays += days;
      });

      return hasTBD
        ? totalDays === 0 ? 'TBD' : `${totalDays} + TBD days`
        : `${totalDays} days`;
    }

    function calculateProjectTotalDays(phases: any[]): string {
      let projectTotalDays = 0;
      let hasTBD = false;

      console.log('Calculating project total days...');

      phases.forEach((phase: any) => {
        const phaseTotalDays = getPhaseTotalDays(phase);

        console.log('Phase Total Days:', phaseTotalDays);

        if (phaseTotalDays.includes('TBD')) {
          hasTBD = true;
        }

        const numericDays = parseInt(phaseTotalDays);
        if (!isNaN(numericDays)) {
          projectTotalDays += numericDays;
        }
      });

      // Return formatted result
      if (projectTotalDays === 0 && hasTBD) {
        return 'TBD';
      } else if (hasTBD) {
        return `${projectTotalDays} + TBD days`;
      } else {
        return `${projectTotalDays} days`;
      }
    }
    const formatDate = (date: string | null) => {
      return date ? common.localDateOnly(date) : '';
    };



    onMounted(() => {
      projectAcknowledgementDetails(invitationId);
      state.data.imageBaseUrl = config.imageBaseUrl;
      state.data.haveProfileSign = false;
      userSignature('onMount');
    });

    return {
      state,
      redirectBack,
      formatDate,
      calculateTaskDays,
      getPhaseTotalDays,
      calculateProjectTotalDays,
      handleImageInNewTab,
      closeAcknowledgementInvitationModal,
      showDeclineModal,
      projectAcknowledgementDetails,
      redirectToChat,
      acceptEstimation,
      declineProject,
      redirectToDoc,
      clearSignature,
      readSignature,
      onDocumentChange,
      showUploadImageModel,
      hideShowUploadImageModel,
      saveSignature,
      validateForm,
      slectedPhases,
      showSignaturePad,
      hideSignaturePad,
      uploadSignature,
      uploadSignatureFile,
      hideSignatureUpload,
      userSignature,
      closeSuccessCustomModal,
      redirectToSmartContractList,
      redirectToDashboard,
      signatureInput
    };
  },
});
